import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShopify,
} from '@fortawesome/free-brands-svg-icons';
import { Button } from '@material-ui/core';

import SimpleTooltip from '@root/components/tooltips/SimpleTooltip';
import ExternalSourceText from '@root/components/integrations/ExternalSource/ExternalSourceText';
import ExternalSourcesContext from '@root/resources/externalSources/externalSources.context';
import AuthContext from '@root/resources/auth/auth.context';

import useStyles from './ShopifyNotConnected.styles';

const ShopifyNotConnected = ({ openModal }) => {
  const classes = useStyles();

  const { currentExternalSource } = ExternalSourcesContext.useExternalSource();
  const { showExternalSourceTooltip } = currentExternalSource.toggles;
  const { currentUser } = AuthContext.useAuth();

  const tooltipContent = showExternalSourceTooltip
    ? <ExternalSourceText />
    : (
      <div>
        There are no Shopify stores connected.
        {currentUser.permissions.installShopify
          && (
            <div className={classes.flex}>
              <Button
                className={classes.button}
                variant="text"
                onClick={openModal}
              >
                Connect
              </Button>
            </div>
          )}
      </div>
    );

  return (
    <SimpleTooltip
      interactive
      content={tooltipContent}
      placement="bottom-start"
    >
      <span>
        <FontAwesomeIcon
          icon={faShopify}
          className={classes.icon}
        />
      </span>
    </SimpleTooltip>
  );
};

export default ShopifyNotConnected;
